import React from 'react';
import {Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography} from "@mui/material";
import {formatMinutes} from "./validationHelpers.js";

// Modal de confirmation avant de valider toutes les semaines d'un opérateur.
// Affiche un résumé de ce qui va être validé (semaines, heures, HS, alertes)
// pour que la confirmation soit un vrai checkpoint et pas un clic réflexe.
export default function ConfirmValidateAllDialog({open, operateurLibelle, periodeMois, resume, onCancel, onConfirm}) {
    return (
        <Dialog open={open} onClose={onCancel}>
            <DialogTitle>Confirmer la validation</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Valider toutes les semaines de <b>{operateurLibelle}</b> pour la période <b>{periodeMois}</b> ?
                </DialogContentText>

                {resume && (
                    <Box sx={{mt: 2, p: 1.5, backgroundColor: "#f5f5f5", borderRadius: 1}}>
                        <Typography variant="body2">
                            <b>{resume.nbSemaines}</b> semaine{resume.nbSemaines > 1 ? "s" : ""} ·{" "}
                            <b>{formatMinutes(resume.totalMinutes)}</b> au total
                            {resume.hsMinutes > 0 && <> · <b>+{formatMinutes(resume.hsMinutes)}</b> HS</>}
                        </Typography>
                    </Box>
                )}

                {resume?.nbAlertes > 0 && (
                    <Alert severity="warning" sx={{mt: 1.5}}>
                        {resume.nbAlertes} alerte{resume.nbAlertes > 1 ? "s" : ""} non contrôlée{resume.nbAlertes > 1 ? "s" : ""} sur cette période.
                        Vérifiez les semaines concernées avant de valider en masse.
                    </Alert>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} color="inherit">Annuler</Button>
                <Button onClick={onConfirm} color="success" variant="contained">Valider tout</Button>
            </DialogActions>
        </Dialog>
    );
}
